var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolanaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92524 15.3056C6.03539 15.2003 6.18472 15.1412 6.34041 15.1412H20.7058C20.9674 15.1412 21.0984 15.444 20.9133 15.621L18.0748 18.3355C17.9646 18.4408 17.8153 18.5 17.6596 18.5H3.29425C3.03258 18.5 2.90158 18.1971 3.08667 18.0201L5.92524 15.3056Z",
    fill: "url(#paint0_linear_147_1729)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92524 5.1645C6.03538 5.05916 6.18471 4.99999 6.34041 5H20.7058C20.9674 5 21.0984 5.30286 20.9133 5.4799L18.0748 8.19438C17.9646 8.29969 17.8153 8.35885 17.6596 8.35885H3.29425C3.03258 8.35885 2.90158 8.05599 3.08667 7.87898L5.92524 5.1645Z",
    fill: "url(#paint1_linear_147_1729)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0748 10.2028C17.9646 10.0974 17.8153 10.0383 17.6596 10.0383H3.29425C3.03258 10.0383 2.90158 10.3411 3.08667 10.5182L5.92524 13.2326C6.03538 13.338 6.18471 13.3971 6.34041 13.3971H20.7058C20.9674 13.3971 21.0984 13.0943 20.9133 12.9172L18.0748 10.2028Z",
    fill: "url(#paint2_linear_147_1729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_1729",
    x1: 15.1691,
    y1: 1.2969,
    x2: 5.89575,
    y2: 19.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_1729",
    x1: 15.1691,
    y1: 1.2969,
    x2: 5.89575,
    y2: 19.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_147_1729",
    x1: 15.1691,
    y1: 1.2969,
    x2: 5.89575,
    y2: 19.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/Solana Icon.b528b74d5f6cfd9786c0d2cd4ded31c1.svg";
export { ForwardRef as ReactComponent };